// extracted by mini-css-extract-plugin
export default {"wrap":"widget-styles__wrap__oo","dropdown":"widget-styles__dropdown__qw","column":"widget-styles__column__wX","clear":"widget-styles__clear__UD"};